export default __webpack_public_path__ + "static/media/bottom-bg-christmas.edb28bf1.webp";